import { useTranslation } from "react-i18next";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { useWarehouses } from "../lib/useWarehouses";

// iter 275: pick a sample warehouse for a quotation. Shows only active,
// non-default warehouses; `allowNone` adds an explicit "not set" option.
export function WarehouseSelect({ value, onChange, disabled, allowNone = true, testId = "warehouse-select", className = "" }) {
  const { t } = useTranslation();
  const { selectable, warehouses } = useWarehouses();
  const current = warehouses.find((w) => w.id === value);
  const options = current && !selectable.some((w) => w.id === value) ? [current, ...selectable] : selectable;
  const stale = !!value && warehouses.length > 0 && !current;
  return (
    <Select value={stale ? "none" : (value || "none")} onValueChange={(v) => onChange(v === "none" ? null : v)} disabled={disabled}>
      <SelectTrigger data-testid={testId} className={`rounded-lg border-gray-300 focus:ring-brand-500 ${className}`}>
        <SelectValue placeholder={t("warehouse.select")} />
      </SelectTrigger>
      <SelectContent className="rounded-lg">
        {allowNone && <SelectItem value="none">{t("warehouse.none")}</SelectItem>}
        {options.map((w) => <SelectItem key={w.id} value={w.id}>{w.name}{w.active ? "" : ` (${t("warehouse.inactive")})`}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}

export function WarehouseTag({ name, testId = "warehouse-tag", className = "" }) {
  const { t } = useTranslation();
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-1 px-1.5 py-0 rounded bg-gray-100 text-gray-600 text-[10px] font-medium whitespace-nowrap ${className}`}>
      <span className="text-gray-400">{t("warehouse.label")}</span>{name || t("warehouse.none")}
    </span>
  );
}
